import { RefObject } from 'react';

export const useScrollManager = (
  answerRefs: RefObject<(HTMLDivElement | null)[]>,
  containerRef: RefObject<HTMLDivElement | null>,
  bottomRef?: RefObject<HTMLDivElement | null>,
) => {
  const scrollToLastAnswer = () => {
    requestAnimationFrame(() => {
      const lastAnswer = answerRefs.current?.[answerRefs.current.length - 1];
      const container = containerRef.current;
      if (lastAnswer && container) {
        const rect = lastAnswer.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();
        const targetScroll = container.scrollTop + (rect.top - containerRect.top) - 80;
        container.scrollTo({ top: targetScroll, behavior: 'smooth' });
      }
    });
  };

  const scrollToAnswer = (index: number) => {
    requestAnimationFrame(() => {
      const answer = answerRefs.current?.[index];
      const container = containerRef.current;
      if (answer && container) {
        const rect = answer.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();
        const targetScroll = container.scrollTop + (rect.top - containerRect.top) - 80;
        container.scrollTo({ top: targetScroll, behavior: 'smooth' });
      }
    });
  };

  const scrollToBottom = () => {
    setTimeout(() => {
      if (bottomRef?.current && containerRef.current) {
        bottomRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
      }
    }, 200);
  };

  return { scrollToLastAnswer, scrollToAnswer, scrollToBottom };
};
